import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import type { GenericList } from './models/JobSharedInterfaces';
import { CheckPermissions, DownloadFile, GetCustomers } from './Shared';

const ReportItemsOnHireData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [customers, setCustomers] = React.useState<GenericList[]>([]);
    const [customerId, setCustomerId] = React.useState(-1);

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunReports");
        if (hasPermission) {
            getCustomersList();
        } else {
            navigate("/accessdenied")
        }
    }

    const getCustomersList = async () => {
        try {
            var customers: GenericList[] = await GetCustomers();
            if (customers.length === 0) {
                toast.error("Error getting customers");
            } else {
                setCustomers(customers);
                setLoading(false);
            }
        } catch (e) {
            toast.error("Error getting customers!");
        }
    }

    const exportReport = (e: any) => {
        e.preventDefault();

        //run the report and export the data
        exportRpt();
    }
 
    const exportRpt = async () => {
        const apiURL = 'RunItemsOnHireReport?CustomerId=' + customerId;
        var filename = "Items On Hire.xlsx";
        await DownloadFile(apiURL, filename);
    }

    const renderDetails = (
        <div>
            <div className="marginBottom20">
                <h1>Items On Hire Currently Report</h1>
                <div>This report will show all jobs installed on site. Select customer if you wish to filter the report by customer.</div>
            </div>
            <div>
                <label className="input-group" htmlFor="customerId">
                    <span className="label">Customer</span>
                    <select className="select" id="customerId" name="customerId" value={customerId} onChange={(e) => setCustomerId(Number(e.target.value))}>
                        <option defaultValue="-1" value="-1"></option>
                        {customers.map(cust =>
                            <option key={cust.id} value={cust.id}>{cust.name}</option>
                        )};
                    </select>
                </label>
            </div>
            <div>
                <button className="defaultbutton marginLeftLabel" type='button' onClick={exportReport}>Run Report</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportItemsOnHireData;